export enum ContactUsMessageTableAction {
  SHOW_MESSAGE = 'show-message',
}

export enum ReviewsReportTableAction {
  SHOW = 'show',
  HIDE = 'hide',
}

export enum ReviewersReviewsReportTableAction {
  SHOW = 'show',
  HIDE = 'hide',
  EDIT = 'edit',
}

export enum BalanceReportTableAction {
  EXTEND = 'extend',
  CANCEL = 'cancel',
}

export enum TeacherUpdateRequestTableAction {
  SHOW_CHANGES = 'show-changes',
  APPROVE_CHANGES = 'approve-changes',
  DECLINE_CHANGES = 'decline-changes',
}

export enum UsersPermissionsTableAction {
  EDIT_USER = 'edit-user',
  ACTIVATE_ACCOUNT = 'activate-account',
  DEACTIVATE_ACCOUNT = 'deactivate-account',
}

export enum ConsultantBalanceTableAction {
  MARK_AS_PAID = 'mark-as-paid',
}

export enum UsersReportTableAction {
  SHOW_REPORT = 'show-report',
  SHOW_SENT_REPORT = 'show-sent-report',
}

export enum StudentsRequestTableAction {
  APPROVE_CHANGES = 'approve',
  DECLINE_CHANGES = 'decline',
}

export enum StudentManagementAction {
  STOP_CALLING_TEACHER = 'stop-calling',
  ALLOW_CALLING_TEACHER = 'allow-calling',
  SUSPEND_ACCOUNT = 'suspend-account',
  ACTIVATE_ACCOUNT = 'activate-account',
  STOP_BUYING_CREDIT = 'stop-buying',
  ALLOW_BUYING_CREDIT = 'allow-buying',
  STOP_VIDEO_CALLS = 'stop-video-calls',
  ALLOW_VIDEO_CALLS = 'allow-video-calls',
  STOP_AUDIO_CALLS = 'stop-audio-calls',
  ALLOW_AUDIO_CALLS = 'allow-audio-calls',
  CHOOSE_CATEGORY = 'choose-category',
  STOP_RESERVATIONS = 'stop-reservations',
  ALLOW_RESERVATIONS = 'allow-reservations',
  DEPENDANTS_MANAGEMENT = 'dependants-managements',
  CHANGE_PASSWORD = 'change-password',
  SHOW_DEVICE_INFO = 'show-device-info',
  ACTIVATE_TEMPORARY_PASSWORD = 'activate-temporary-password',
  DEACTIVATE_TEMPORARY_PASSWORD = 'deactivate-temporary-password',
  EDIT_BALANCE = 'edit-balance',
}

export enum StudentPackagesAction {
  RETURN_MONEY = 'return-money',
}

export enum TeachersTableAction {
  CATEGEORY_REMOVING = 'category-removing',
  RESET_THE_ACCOUNT_BALANCE = 'reset-account-balance',
  RESET_THE_ACCOUNT_BALANCE_FROM_TO_DATE = 'clearing-the-account-balance-with-date',
  CHOOSE_CATEGORY = 'choose-category',
  ACTIVATING_SCHEDULE = 'activate-schedule',
  DEACTIVATING_SCHEDULE = 'deactivate-schedule',
  CHANGE_PASSWORD = 'change-password',
  DEACTIVATE = 'deactivate-account',
  APPROVE = 'approve',
  DECLINE = 'decline',
  SUSPEND_ACCOUNT = 'suspend-account',
  ACTIVATE = 'activate-account',
  SHOW_DEVICE_INFO = 'show-device-info',
  ACTIVATE_TEMPORARY_PASSWORD = 'activate_temporary_password',
  DEACTIVATE_TEMPORARY_PASSWORD = 'deactivate_temporary_password',
  EDIT_SESSION_PRICE = 'edit-session-price',
  EDIT_TEACHER = 'edit-teacher',
  DELETE_TEACHER = 'delete-teacher',
}

export enum SessionDetailsRecordAction {
  EDIT_RECORD = 'Edit-Record',
}

export enum DiscountCodesTableAction {
  EDIT_CODE = 'edit-code',
  DELETE_CODE = 'delete-code',
}

export enum AdsTableAction {
  DELETE_AD = 'delete-ad',
  EDIT_AD = 'edit-ad',
}

export enum CategoriesButtonAction {
  DELETE_CATEGORY = 'delete-category',
  EDIT_CATEGORY = 'edit-category',
}

export enum TeacherCategoriesPopupButtonAction {
  DELETE_TEACHER = 'delete-teacher',
}

export enum DynamicLinksButtonAction {
  COPY_LINK = 'copy-link',
}

export enum PeakHoursTableAction {
  EDIT_PEAK_HOUR = 'edit-peak-hour',
  SAVE_PEAK_HOUR = 'save-peak-hour',
  CLOSE_EDITING = 'close-editing',
}

export enum CallSharedFilesTableAction {
  DELETE_FILE = 'delete-file',
  DOWNLOAD_FILE = 'download-file',
}

export enum FAQCategoriesTableAction {
  EDIT_CATEGORY = 'edit-category',
  DELETE_CATEGORY = 'delete-category',
}

export enum FaqTableAction {
  EDIT_QUESTION = 'edit-question',
  DELETE_QUESTION = 'delete-question',
}

export enum MarketPlaceTableAction {
  EDIT_PACKAGE = 'edit-package',
  HIDE_PACKAGE = 'hide-package',
  SHOW_PACKAGE = 'show-package',
  DELETE_PACKAGE = 'delete-package',
}

export enum SpecialOfferStudentsTableAction {
  DELETE_STUDENT = 'delete-student',
}

export enum MarketPlaceProductsTableAction {
  EDIT_PRODUCT = 'edit-product',
  HIDE_PRODUCT = 'hide-product',
  SHOW_PRODUCT = 'show-product',
  DELETE_PRODUCT = 'delete-product',
}

export enum ExcelFileTableAction {
  CHECK_ERRORS = 'check-errors',
  EDIT_ROW = 'edit-row',
  DELETE_ROW = 'delete-row',
}

export enum BeneficiariesTableAction {
  EDIT_BENEFICIARY = 'edit-beneficiary',
  DELETE_BENEFICIARY = 'delete-beneficiary',
  ADJUST_USER_BALANCE = 'adjust-user-balance',
}

export enum TeacherJoinRequestTableAction {
  SHOW_DETAILS = 'show-details',
}

export enum ReceivablesTableAction {}

export enum DependentsTableAction {
  DELETE_DEPENDENT = 'delete-dependent',
  ADD_BALANCE = 'add-balance',
  RESTORE_BALANCE = 'restore-balance',
  EDIT_ACCOUNT = 'edit-account',
  MOVE_DEPENDENT = 'move-dependent',
}

export enum ExtractReportsTableAction {
  DOWNLOAD_REPORT = 'download-report',
}

export enum StudentsPlansReportTableAction {
  DELETE_REPORT = 'delete-report',
}

export enum ScheduledNotificationsTableAction {
  DELETE_NOTIFICATION = 'delete-notification',
}

export enum FatihaRequestsTableAction {
  ACCEPT_REQUEST = 'accept',
  REJECT_REQUEST = 'reject',
  NAVIGATE_TO_SESSION = 'navigate',
}
